export class Manufacturer {
  uuid: string | null;
  name: string;
}
